'use client';

import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';

interface CostStepProps {
  control: Control<any>;
  errors: FieldErrors;
  isEdit: boolean;
}

export default function CostStep({ control }: CostStepProps) {
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <h3 className="text-lg font-semibold mb-2">Full-Time Costs</h3>
        <div className="grid grid-cols-2 gap-4">
          <FormField
            control={control}
            name="fullTimeCost"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="xl:text-sm ml-1">
                  Full Time Rate ($/month)
                </FormLabel>
                <FormControl>
                  <Input
                    className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                    {...field}
                    placeholder="2000"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="fullTimeRegistrationCost"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="xl:text-sm ml-1">
                  Registration Cost ($)
                </FormLabel>

                <FormControl>
                  <Input
                    className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                    {...field}
                    placeholder="90"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={control}
          name="fullTimeSuppliesCost"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="xl:text-sm ml-1">
                Supplies Cost ($)
              </FormLabel>

              <FormControl>
                <Input
                  className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                  {...field}
                  placeholder="60"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="space-y-1">
        <h3 className="text-lg font-semibold mb-2">Part-Time Costs</h3>
        <div className="grid grid-cols-2 gap-4">
          <FormField
            control={control}
            name="partTimeCost"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="xl:text-sm ml-1">
                  Part-Time Rate ($/month)
                </FormLabel>
                <FormControl>
                  <Input
                    className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                    {...field}
                    placeholder="4000"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="partTimeRegistrationCost"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="xl:text-sm ml-1">
                  Registration Cost ($)
                </FormLabel>

                <FormControl>
                  <Input
                    className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                    {...field}
                    placeholder="50"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={control}
          name="partTimeSuppliesCost"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="xl:text-sm ml-1">
                Supplies Cost ($)
              </FormLabel>

              <FormControl>
                <Input
                  className="border-1 placeholder:text-muted-foreground placeholder:text-sm"
                  {...field}
                  placeholder="30"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Financial Aid</h3>
        <div className="space-y-2">
          <FormField
            control={control}
            name="doesProvideScholarships"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel>Provides Scholarships</FormLabel>
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="doesProvideGrants"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center space-x-3 space-y-0">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel>Provides Grants</FormLabel>
                </div>
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}
